/**
 * Which CTAs the flashcards empty state shows, and how loud each one is.
 *
 * The rule the designer asked for ("as simple as the quiz one"): ONE primary
 * action. When the set can generate, Generate is that action and "Write your
 * own" sits under it as a quiet ghost button; when it cannot, "Write your own"
 * takes the primary slot rather than leaving the card with only a whisper of
 * an action. No action at all is legitimate (a read-only viewer).
 *
 * Pure so it is pinned without a renderer, and so web and mobile cannot answer
 * it differently.
 */
export type FlashcardsEmptyStateWriteEmphasis = 'primary' | 'quiet';

export interface FlashcardsEmptyStateActionPlan {
  showGenerate: boolean;
  /** `null` = no Write-your-own button. */
  writeOwn: FlashcardsEmptyStateWriteEmphasis | null;
}

export function flashcardsEmptyStateActions({
  hasGenerate,
  hasWriteOwn,
}: {
  hasGenerate: boolean;
  hasWriteOwn: boolean;
}): FlashcardsEmptyStateActionPlan {
  return {
    showGenerate: hasGenerate,
    writeOwn: hasWriteOwn ? (hasGenerate ? 'quiet' : 'primary') : null,
  };
}
